<template>
  <div>
    <el-form inline class="chat-menu">
      <el-form-item label="AI回答">
        <el-switch
          v-model="manual"
          @change="handelSetManual"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          @click="handelMore"
        >
          更多聊天记录
        </el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="showMemberInfo">
      <el-table :data="questions">
        <el-table-column
          prop="props"
          label="问题"
        >
          <template slot-scope="scope">
            {{ scope.row['props']['label'] ? scope.row['props']['label'] : scope.row['id'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="answer"
          label="答案"
        >
          <template slot-scope="scope">
            {{ JSON.stringify(scope.row['answer']['answer']) }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'CustomServiceMenu',
    props: {
      userInfo: {
        type: Object,
        default: () => { return {} }
      }
    },
    data: function () {
      return {
        manual: true,
        showMemberInfo: false,
        questions: [],
      }
    },
    watch: {
      userInfo() {
        this.manual = !this.userInfo.manual
      }
    },
    methods: {
      handelSetManual: function (status) {
        if (this.userInfo.uid) {
          this.$emit('changeUserManual', { uid: this.userInfo.uid, status: !status })
        } else {
          this.$message.error('未选择用户')
        }
      },
      handelMore: function () {
        this.$emit('messageMore', this.userInfo.uid)
      }
    }
  }
</script>
<style>
  .chat-menu .el-form-item {
    margin: 0;
  }
</style>